var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 95.4895V185C3 190.523 7.47716 195 13 195H88.8838H164.768C170.291 195 174.768 190.523 174.768 185V95.4895C174.768 92.8469 173.722 90.3119 171.858 88.4381L95.9746 12.1303C92.0649 8.19881 85.7028 8.19881 81.7931 12.1304L5.90926 88.4381C4.04594 90.3119 3 92.8469 3 95.4895Z",
    stroke: "#062134",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 100H175",
    stroke: "#062134",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 150H174",
    stroke: "#062134",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsLevel);
export default __webpack_public_path__ + "static/media/ico_buildings_level.788908b200819f3dceafd3da6524c666.svg";
export { ForwardRef as ReactComponent };